var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBooks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 51,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M25.752 24.327c-4.08 0-7.424-5.464-7.424-9.888s2.776-7.008 5.952-7.008S28.2 9 28.2 9s1.52-1.553 4.688-1.553 5.952 2.608 5.952 7.024-3.344 9.856-7.424 9.856"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m35.856 31.191-2.736-1.688-2.736 1.688v-6.616h5.472z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1EDDF6",
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M32.736 1.4c-.784.04-2.36.248-3.368 1.256s-1.216 2.584-1.256 3.368c.784-.04 2.36-.248 3.368-1.256s1.216-2.584 1.256-3.368"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M48.984 38.997H13.928c-4.032 0-7.336-3.304-7.336-7.336s3.304-7.336 7.336-7.336h35.056"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M46.384 38.997c-2.496 0-4.528-3.304-4.528-7.336s2.04-7.336 4.528-7.336M1 39.063h48.136c2.992 0 5.44 2.447 5.44 5.44 0 2.992-2.448 5.44-5.44 5.44H1"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#3E3F5F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.928 39.063c1.848 0 3.36 2.447 3.36 5.44 0 2.992-1.512 5.44-3.36 5.44M13.8 45.4h32"
})));
export { SvgBooks as ReactComponent };
export default __webpack_public_path__ + "64686f8d1864f3949f6e3fe1c5f5f9ea.svg";